import {
  Text,
  TextFontSizes,
  TextFontWeights,
  TextLineHeights,
} from '@cinch-labs/design-system'
import styles from './how-it-works.module.css'

interface HowItWorksStepProps {
  i18n: {
    title: string
    text?: string
  }
  Image: React.FC
  className?: string
  children?: React.ReactNode
}

const HowItWorksStep = ({ i18n, Image, children }: HowItWorksStepProps) => (
  <li>
    <div className={styles.howItWorksImage}>
      <Image aria-hidden="true" />
    </div>
    <Text
      className={styles.howItWorksTitle}
      element="h3"
      fontSize={TextFontSizes.l}
      fontWeight={TextFontWeights.bold}
      lineHeight={TextLineHeights.display}
    >
      {i18n.title}
    </Text>
    {children ? (
      children
    ) : (
      <Text fontSize={TextFontSizes.m} fontWeight={TextFontWeights.book}>
        {i18n.text}
      </Text>
    )}
  </li>
)

export default HowItWorksStep
